__turbopack_context__.v({
  "active": "HeroCarousel-module__k565gG__active",
  "carouselContainer": "HeroCarousel-module__k565gG__carouselContainer",
  "carouselTrack": "HeroCarousel-module__k565gG__carouselTrack",
  "dot": "HeroCarousel-module__k565gG__dot",
  "dotVisual": "HeroCarousel-module__k565gG__dotVisual",
  "dotsContainer": "HeroCarousel-module__k565gG__dotsContainer",
  "dragging": "HeroCarousel-module__k565gG__dragging",
  "slide": "HeroCarousel-module__k565gG__slide",
  "slideImage": "HeroCarousel-module__k565gG__slideImage",
});
